var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBoleto = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:invoice-list-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.833 14V16H23.833V14H25.833ZM21.833 14V16H15.833V14H21.833ZM21.833 18H15.833V20H21.833V18ZM23.833 18V20H25.833V18H23.833ZM29.833 29L26.833 27L23.833 29L20.833 27L17.833 29L14.833 27L11.833 29V10H29.833V29ZM27.833 25.26V12H13.833V25.26L14.833 24.6L17.833 26.6L20.833 24.6L23.833 26.6L26.833 24.6L27.833 25.26Z",
    fill: "#955CFF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBoleto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/boleto.c1cc0f80.svg";
export { ForwardRef as ReactComponent };